export default __webpack_public_path__ + "static/media/move-up.7857acac.svg";